<template>
  <div :class="{ root: !onHud }">
    <div class="clock-circle" :class="{ onHud: onHud }">
      <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <g>
          <circle cx="50" cy="50" r="45" />
          <path
            :stroke-dasharray="circleDashArray"
            :class="{
              green: isOverWarningTime,
              orange: isBetweenWarningAndAlertTime,
              red: isUnderAlertTime,
              white: timeIsOver,
            }"
            d="
          M 50, 50
          m -45, 0
          a 45,45 0 1,0 90,0
          a 45,45 0 1,0 -90,0
        "
          ></path>
        </g>
      </svg>
      <span
        class="clock-timer"
        :class="{
          green: isOverWarningTime,
          orange: isBetweenWarningAndAlertTime,
          red: isUnderAlertTime,
          white: timeIsOver,
          onHud: onHud,
        }"
      >
        {{ formattedTimeLeft }}
      </span>
    </div>
    <div class="tip-group" v-if="!onHud">
     <!-- <span
        class="tip"
        :class="{
          green: isOverWarningTime,
          orange: isBetweenWarningAndAlertTime,
          red: isUnderAlertTime,
        }"
        >{{ tip }}</span
      >
      <img src="@/assets/images/life.svg" width="35px" height="35px" alt="" />-->
    </div>
  </div>
</template>

<script>
let WARNING_THRESHOLD = 10;
let ALERT_THRESHOLD = 5;

export default {
  props: {
    timeLeft: {
      type: Number,
      required: true,
      default: 0,
    },
    initialTime: {
      type: Number,
      required: true,
      default: 0,
    },
    onHud: {
      type: Boolean,
      default: false,
    },
    tip: {
      type: String,
      default: "",
    },
  },
  computed: {
    timeToAnswer() {
      WARNING_THRESHOLD = (this.initialTime / 3) * 2;
      ALERT_THRESHOLD = this.initialTime / 3;
      return this.initialTime;
    },
    isOverWarningTime() {
      return this.timeLeft >= WARNING_THRESHOLD;
    },
    isBetweenWarningAndAlertTime() {
      return (
        this.timeLeft < WARNING_THRESHOLD && this.timeLeft >= ALERT_THRESHOLD
      );
    },
    isUnderAlertTime() {
      return this.timeLeft < ALERT_THRESHOLD;
    },
    timeIsOver() {
      return this.timeLeft < 0;
    },
    formattedTimeLeft() {
      return this.timeLeft == Number.POSITIVE_INFINITY
        ? "∞"
        : `${this.timeLeft}"`;
    },
    // Divides time left by the defined time limit.
    timeFraction() {
      return this.timeLeft / this.timeToAnswer;
    },
    // Update the dasharray value as time passes, starting with 283
    circleDashArray() {
      return `${(this.timeFraction * 283).toFixed(0)} 283`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";

.clock-circle {
  position: relative;
  width: 15rem;
  height: 15rem;
}

/* Sets the containers height and width */
.onHud {
  position: relative;
  width: 3rem;
  height: 3rem;
}

/* Removes SVG styling that would hide the time label */
g {
  fill: none;
  stroke: none;
}

/* The SVG path that displays the timer's progress */
circle {
  stroke-width: 0.5rem;
  stroke: $quaternary-lighter;
}

.clock-timer {
  font-family: $secondary-font;
  position: absolute;

  /* Size should match the parent container */
  width: 15rem;
  height: 15rem;

  /* Keep the label aligned to the top */
  top: 0;

  /* Create a flexible box that centers content vertically and horizontally */
  display: flex;
  align-items: center;
  justify-content: center;

  /* Sort of an arbitrary number; adjust to your liking */
  font-size: 5rem;
}

.onHud {
  width: 3rem;
  height: 3rem;
  font-size: 1.4rem;
}

path {
  /* Just as thick as the original ring */
  stroke-width: 0.5rem;

  /* Rounds the line endings to create a seamless circle */
  stroke-linecap: round;

  /* Makes sure the animation starts at the top of the circle */
  transform: rotate(90deg);
  transform-origin: center;

  /* One second aligns with the speed of the countdown timer */
  transition: 1s linear all;

  /* Allows the ring to change color when the color value updates */
  stroke: currentColor;
}

svg {
  /* Flips the svg and makes the animation to move left-to-right */
  transform: scaleX(-1);
}

.green {
  color: $secondary;
}

.orange {
  color: $sexternary;
}

.red {
  color: $tertiary;
}

.white {
  color: $quaternary-lighter;
}

.tip {
  position: relative;
  font-family: $secondary-font;
  font-size: 1rem;
  text-align: center;
  width: 100%;
  margin-right: 0.3rem;
}

.tip-group {
  display: inline-flex;
  align-items: center;
  margin-top: 2rem;
}
</style>
